import type { TypographyVariantsOptions } from "@mui/material/styles";

export const typography: TypographyVariantsOptions = {
  fontFamily: ["YekanBakhFaNum"].join(","),

  h1: {
    fontSize: "2.5rem",
    fontWeight: 700,
  },

  h2: {
    fontSize: "2rem",
    fontWeight: 700,
  },

  h3: {
    fontSize: "1.75rem",
    fontWeight: 600,
  },

  h4: {
    fontSize: "1.5rem",
    fontWeight: 600,
  },

  h5: {
    fontSize: "1.25rem",
    fontWeight: 600,
  },

  h6: {
    fontSize: "1rem",
    fontWeight: 600,
  },

  body1: {
    fontSize: "1rem",
  },

  body2: {
    fontSize: "0.875rem",
  },

  button: {
    textTransform: "none",
    fontWeight: 600,
  },
};
